import * as cnt from './constants';

// export const openModal = () => { return { type: cnt.OPENMODAL }; };
export const openModal = () => () => {
  window.location = `${process.env.NEW_SYSTEM_URL}/partner-management/send-assets?jwt=${localStorage.getItem('jwt')}&go_back_to=${window.location.href}`;
};
export const closeModal = () => { return { type: cnt.CLOSEMODAL }; };
export const sendMessage = (payload) => {return { type: cnt.SENDMESSAGE, payload };};



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/store/actions.js